<template>
  <el-table
    :data="tableData"
    border
    fit
    highlight-current-row
    style="width: 100%"
    v-loading="loading"
    show-summary
    :summary-method="getSummaries"
  >
    <el-table-column
      prop="productId"
      label="商品编号"
      align="center"
    />
    <el-table-column
      prop="prodName"
      label="商品名称"
      align="center"
    />
    <el-table-column
      prop="barCode"
      label="条码"
      align="center"
    />
    <el-table-column
      prop="totalAmount"
      label="金额"
      align="center"
    >
      <template slot-scope="scope">
        {{ formatValue('totalAmount', scope.row.totalAmount) }}
      </template>
    </el-table-column>
    <el-table-column
      prop="returnCartNum"
      label="退货数量"
      align="center"
    >
      <template slot-scope="scope">
        {{ formatValue('returnCartNum', scope.row.returnCartNum) }}
      </template>
    </el-table-column>
    <el-table-column
      prop="returnPayPrice"
      label="退货金额"
      align="center"
    >
      <template slot-scope="scope">
        {{ formatValue('returnPayPrice', scope.row.returnPayPrice) }}
      </template>
    </el-table-column>
    <el-table-column
      prop="actualCartNum"
      label="实售数量"
      align="center"
    >
      <template slot-scope="scope">
        {{ formatValue('actualCartNum', scope.row.actualCartNum) }}
      </template>
    </el-table-column>
    <el-table-column
      prop="salesRevenue"
      label="销售收入"
      align="center"
    >
      <template slot-scope="scope">
        {{ formatValue('salesRevenue', scope.row.salesRevenue) }}
      </template>
    </el-table-column>
    <el-table-column
      prop="salesCost"
      label="成本"
      align="center"
    >
      <template slot-scope="scope">
        {{ formatValue('salesCost', scope.row.salesCost) }}
      </template>
    </el-table-column>
    <el-table-column
      prop="grossMargin"
      label="毛利"
      align="center"
    >
      <template slot-scope="scope">
        {{ formatValue('grossMargin', scope.row.grossMargin) }}
      </template>
    </el-table-column>
    <el-table-column
      prop="lossMoney"
      label="亏损金额"
      align="center"
    >
      <template slot-scope="scope">
        {{ formatValue('lossMoney', scope.row.lossMoney) }}
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
const SUMMARY_FIELDS = [
  'totalAmount',
  'returnCartNum',
  'returnPayPrice',
  'actualCartNum',
  'salesRevenue',
  'salesCost',
  'grossMargin',
  'lossMoney'
]

const MONEY_FIELDS = [
  'totalAmount',
  'returnPayPrice',
  'salesRevenue',
  'salesCost',
  'grossMargin',
  'lossMoney'
]

const QUANTITY_FIELDS = [
  'returnCartNum',
  'actualCartNum'
]

export default {
  name: 'SellingCostDetailTable',
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    sumTotal: {
      type: Object,
      default: () => ({})
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    formatValue(field, value) {
      if (value === null || value === undefined || value === '') {
        return ''
      }
      const num = Number(value)
      if (Number.isNaN(num)) {
        return value
      }
      if (MONEY_FIELDS.includes(field)) {
        return num.toFixed(2)
      }
      if (QUANTITY_FIELDS.includes(field)) {
        return num.toFixed(3)
      }
      return num
    },
    getSummaries({ columns }) {
      const summaryByIndex = [
        '总计',
        '',
        '',
        'totalAmount',
        'returnCartNum',
        'returnPayPrice',
        'actualCartNum',
        'salesRevenue',
        'salesCost',
        'grossMargin',
        'lossMoney'
      ]
      const sums = []
      columns.forEach((column, index) => {
        const field = column.property || summaryByIndex[index]
        if (index === 0 || field === '总计') {
          sums[index] = '总计'
          return
        }
        if (field === 'productId' || field === 'prodName' || field === 'barCode' || !field) {
          sums[index] = ''
          return
        }
        if (SUMMARY_FIELDS.includes(field)) {
          sums[index] = this.formatValue(field, this.sumTotal[field])
          return
        }
        sums[index] = ''
      })
      return sums
    }
  }
}
</script>

<style lang="scss" scoped>
.el-table {
  margin-top: 20px;
}
</style>
